<template>
  <div class="statistics container">
    <!-- <div class="top_info">
      <div class="title">学情统计</div>
      <div class="class_info">
        <span>班级：{{ classInfo.name }}</span>
        <span>团队数：{{ classInfo.teamCount }}个</span>
        <span>学生数：{{ classInfo.studentCount }}人</span>
      </div>
    </div> -->
    <div class="main">
      <!-- <div class="course_info">
        <p class="info_title">课程概况</p>
        <div class="content">
          <p>{{ $route.query.chapterTitle }}</p>
        </div>
      </div> -->

      <div class="data">
        <p class="data_title">学情统计</p>
        <table
          width="100%"
          border="1"
          cellspacing="0"
          cellpadding="20"
          align="center"
        >
          <tr
            style="font-weight: bold; text-align: center; background: #d8d8d8"
          >
            <td>微课</td>
            <td>PPT</td>
            <td>练习</td>
            <td>实操</td>
          </tr>
          <tr style="text-align: center">
            <td
              @click="
                $router.push({
                  path: '/courseDetail/statistics/detail',
                  query: {
                    ...$route.query,
                    type: 'video',
                  },
                })
              "
            >
              {{ statisticsinfo.videoRate }}%
            </td>
            <td
              @click="
                $router.push({
                  path: '/courseDetail/statistics/detail',
                  query: {
                    ...$route.query,
                    type: 'ppt',
                  },
                })
              "
            >
              {{ statisticsinfo.pptRate }}%
            </td>
            <td
              @click="
                $router.push({
                  path: '/courseDetail/statistics/detail',
                  query: {
                    ...$route.query,
                    type: 'test',
                  },
                })
              "
            >
              {{ statisticsinfo.testRate }}%
            </td>
            <td
              @click="
                $router.push({
                  path: '/courseDetail/statistics/detail',
                  query: {
                    ...$route.query,
                    type: 'works',
                  },
                })
              "
            >
              {{ statisticsinfo.szRate }}%
            </td>
          </tr>
        </table>

        <!-- <div
          class="one"
          @click="
            $router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ...$route.query,
                type: 'video',
              },
            })
          "
        >
          <p>微课</p>
          <el-progress
            type="circle"
            :stroke-width="1"
            :percentage="statisticsinfo.videoRate"
          ></el-progress>
        </div>
        <div
          class="one"
          @click="
            $router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ...$route.query,
                type: 'ppt',
              },
            })
          "
        >
          <p>PPT</p>
          <el-progress
            type="circle"
            :stroke-width="1"
            :percentage="statisticsinfo.pptRate"
          ></el-progress>
        </div>
        <div
          class="one"
          @click="
            $router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ...$route.query,
                type: 'test',
              },
            })
          "
        >
          <p>测试</p>
          <el-progress
            type="circle"
            :stroke-width="1"
            :percentage="statisticsinfo.testRate"
          ></el-progress>
        </div>
        <div
          v-show="statisticsinfo.szRate || statisticsinfo.szRate == 0"
          class="one"
          @click="
            $router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ...$route.query,
                type: 'works',
              },
            })
          "
        >
          <p>实操</p>
          <el-progress
            type="circle"
            :stroke-width="1"
            :percentage="statisticsinfo.szRate"
          ></el-progress>
        </div> -->
        <!-- <div class="one">
          <p>随堂练习</p>
          <el-progress
            type="circle"
            :stroke-width="12"
            :percentage="(info.lianxi / info.studentNum).toFixed(2) * 100"
            :format="(percentage) => format(percentage, info.lianxi)"
          ></el-progress>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { chapterStatistics } from "@/api/chapter";
import { classInfo } from "@/api/class";
export default {
  props: {
    info: Object,
  },
  data() {
    return {
      classInfo: {},
      statisticsinfo: {
        pptRate: 0,
        szRate: 0,
        testRate: 0,
        videoRate: 0,
      },
    };
  },
  activated() {
    this.getClassInfo();
    this.getStatistics();
  },
  methods: {
    // 班级信息
    getClassInfo() {
      classInfo(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          // console.log(res);
          this.classInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    getStatistics() {
      this.$loading.show();
      chapterStatistics(this.$route.query.classChapterId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.statisticsinfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.statistics {
  padding-top: 20px;
  height: 100%;
  .top_info {
    .title {
      padding: 5px;
      color: #fff;
      font-size: 18px;
      background-color: teal;
    }
    .class_info {
      padding: 5px;
      color: teal;
      font-size: 16px;
      border: solid 1px teal;
      span {
        margin-right: 20px;
      }
    }
  }
  .main {
    height: calc(100% - 67px - 20px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .course_info {
      margin-top: 30px;
      padding: 20px;
      text-align: left;
      border: solid 1px teal;
      border-radius: 8px;
      .info_title {
        color: teal;
        font-size: 16px;
      }
      .content {
        margin-top: 10px;
        padding: 10px;
        background-color: #00808054;
        p {
          color: #333;
          line-height: 1.5;
        }
      }
    }

    .data {
      margin-top: 30px;
      padding: 20px;
      text-align: left;
      // border: solid 1px teal;
      border-radius: 8px;
      .data_title {
        margin-bottom: 30px;
        text-align: center;
        font-weight: bold;
        color: teal;
        font-size: 24px;
      }
      .one {
        display: inline-block;
        margin: 0 50px;
        width: 125px;
        text-align: center;
        cursor: pointer;
        p {
          margin-bottom: 20px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>